import { Component, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Workspace | Crafttor';
  showHead: boolean = true;
  showFoot: boolean = true;

  isHomePage: boolean = false;

  constructor(
    private router: Router,
    private renderer: Renderer2,
    private elRef: ElementRef,
  ) {

  }

  onActivate(event) {
  let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
          window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
          window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.checkIfHomePage();
    });

    // Initial check in case we start on the homepage
    this.checkIfHomePage();

    this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }
        window.scrollTo(0, 0);
        // Hide nabar when component changed
        this.renderer.removeClass(this.elRef.nativeElement.querySelector('#navbarResponsive'), 'show')
    });
  }

  private checkIfHomePage() {
    const currentUrl = this.router.url;
    this.isHomePage = currentUrl === '/' || currentUrl === '/home';
  }
}
